import { createContext } from "react";

const ShareCapitalContext = createContext({});

export default ShareCapitalContext;
